import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher/LanguageSwitcher';
import { useAuth } from '../../context/AuthContext';
import styles from './Header.module.css';

interface HeaderProps {
  onSidebarToggle: () => void;
}

const Header: React.FC<HeaderProps> = ({ onSidebarToggle }) => {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isLoggedIn, logout } = useAuth();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <header className={styles.header}>
      <img src="/assets/images/logo_svg.svg" alt="Logo" className={styles.logo} />

      <div className={styles.hamburgerSection}>
        {/* Hamburger Icon */}
        <div className={styles.hamburger} onClick={toggleMenu}><img src="/assets/images/language.svg" alt="Language" /></div>

        {/* Menu */}
        <nav className={`${styles.menu} ${isMenuOpen ? styles.open : ''}`}>
          <LanguageSwitcher />
          {isLoggedIn && (
            <button onClick={logout} className={styles.logoutButton}>
              {t('Header.Logout')}
            </button>
          )}
        </nav>
        {isLoggedIn && (
          <button className={styles.sidebarHamburger} onClick={onSidebarToggle}>
            &#9776;
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;

